var render = function render(){var _vm=this,_c=_vm._self._c;return _c('change-password-form',{attrs:{"token":_vm.token}})
}
var staticRenderFns = []

export { render, staticRenderFns }